import React from 'react'
import Tooltip from 'react-tooltip'
import { connect } from 'react-redux'
import Modal from 'react-responsive-modal'
import Pagination from 'react-js-pagination'
import MarkupActions from '../../Redux/MarkupRedux'
import PresetActions from '../../Redux/PresetRedux'
import PrecisionRound from '../../Utils/PrecisionRound'
import FormCreate from '../../Containers/Markup/FormCreate'
import FormUpdate from '../../Containers/Markup/FormUpdate'
import FormDelete from '../../Containers/Markup/FormDelete'
import PriceComparison from '../../Containers/Markup/PriceComparison'
import ComparisonDetails from '../../Containers/Markup/ComparisonDetails'
import { currentBranch } from '../../Utils/PrivilegeUtils'
import FormatMoney from '../../Utils/FormatMoney'

class Markup extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      showModal: null,
      detail: {},
      general_markup: '',
      branch: {
        country: '',
        product: '',
        value: ''
      },
      q: '',
      sort: {
        value: 'value'
      },
      page: 1
    }
  }

  componentDidMount = () => {
    this.props.getBranch()
    this._fetchMarkup()
  }

  _searchMarkup = (event) => {
    if (event) event.preventDefault()
    const filter = {
      q: this.state.q
    }
    this.props.getMarkup(filter)
  }

  _fetchMarkup = (event, custom) => {
    if (event) event.preventDefault()
    const filter = {
      page: this.state.page,
      q: this.state.q,
      sort: {
        value: this.state.sort.value
      },
      ...custom
    }
    filter.sort = filter.sort.value
    this.props.getMarkup(filter)
  }

  _toggleSort = (field) => {
    let sort = { ...this.state.sort }
    if (sort[field] === field) {
      sort[field] = `-${field}`
    } else {
      sort[field] = field
    }
    this.setState({ sort })
    this._fetchMarkup(null, { sort })
  }

  _changePage = (page) => {
    this.setState({ page })
    this._fetchMarkup(null, { page })
  }

  _updateGeneralMarkup = (event) => {
    event.preventDefault()
    const data = {
      general_price_offset: this.state.general_markup
    }
    this.props.updateGeneralMarkup(data)
    this._toggleModal()
  }

  _updateBranch = (event, country, product) => {
    event.preventDefault()
    const data = {
      country,
      product,
      value: parseInt(this.state.branch.value, 10)
    }
    this.props.updateBranch(data)
    this._toggleModal()
  }

  _toggleModal = (modalId = null) => {
    this.setState({ showModal: modalId })
  }

  _selectItem = (item, action) => {
    this.setState({ detail: item })
    this._toggleModal(action)
  }

  _selectGeneral = (value, modalID) => {
    if (modalID === 'edit-general') {
      this.setState({ general_markup: value })
    } else if (modalID === 'branch-ph') {
      this.setState({ branch: { value: value } })
    }
    this._toggleModal(modalID)
  }

  _valueChange = (e, field) => {
    let value = e.target.value
    if (parseFloat(value) > 100) {
      value = 100
    } else if (parseFloat(value) < -100) {
      value = -100
    }
    switch (field) {
      case 'general_markup':
        return this.setState({ general_markup: value })
      case 'branch-ph':
        return this.setState({ branch: { value: value } })
      default:
        return null
    }
  }

  _renderTable = (markup) => {
    return (
      <section>
        <div className='title-block'>
          <p className='title-description'>Filter:</p>
          <form className='form-inline' onSubmit={(event) => this._searchMarkup(event)}>
            <div className='form-group'>
              <label htmlFor='title' className='control-label mr-2'>Title</label>
              <input type='text' className='form-control' placeholder='Attraction Title' defaultValue={this.state.q} onChange={(event) => this.setState({ q: event.target.value })} />
            </div>
            <div className='form-group ml-2 mt-1'>
              <button type='submit' className='btn btn-primary'>Apply Filter</button>
            </div>
          </form>
        </div>

        <div className='section'>
          <div className='card'>
            {
              !(markup.fetching || markup.processing) && markup.err &&
              <div className='alert alert-danger'>{markup.err}</div>
            }

            <div className='card-block'>
              <table className='table table-hover table-striped' style={{ minWidth: '100%' }}>
                <thead>
                  <tr>
                    <th>Attraction Title</th>
                    <th>City</th>
                    <th className='text-center'>Provider</th>
                    <th className='text-center' role='button' onClick={() => this._toggleSort('value')}>Markup Value <span className='badge badge-info'><i className={`fas fa-${this.state.sort.value === '-value' ? 'sort-amount-down' : 'sort-amount-up'}`} /></span></th>
                    <th className='text-center'>Current Price</th>
                    <th className='text-center'>Predictive Value</th>
                    <th className='text-center'>Predictive Price</th>
                    <th className='text-center'>Package Markup</th>
                    <th className='text-center'>Delete</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    (markup.data && markup.data.data.length) ? markup.data.data.map((item, i) => (
                      <tr key={i}>
                        <td>{ item.attraction && item.attraction.title }</td>
                        <td>{ item.attraction && item.attraction.locations[0].city }</td>
                        <td className='text-center'>{ item.attraction && item.attraction.provider }</td>
                        <td data-tip={'Click to change markup value'} className='text-center' role='button' onClick={() => this._selectItem(item, 'edit')}>
                          <Tooltip />
                          <span className={`badge badge-${item.value > 1 ? 'success' : (item.value === 1 ? 'light' : 'danger')}`}>
                            { item.value > 1 && '+' }{ PrecisionRound((item.value - 1) * 100) } %
                          </span>
                        </td>
                        <td className='text-center'>{ FormatMoney(item.current_price) }</td>
                        <td data-tip={'Click to change predictive value'} className='text-center' role='button' onClick={() => this._selectItem(item, 'comparison')}>
                          <Tooltip />
                          <span className={`badge badge-${item.test_value > 1 ? 'success' : (item.test_value === 1 ? 'light' : 'danger')}`}>
                            { item.test_value > 1 && '+' }{ PrecisionRound((item.test_value - 1) * 100) } %
                          </span>
                        </td>
                        <td className='text-center'>{ FormatMoney(item.preview_price) }</td>
                        <td className='text-center'>
                          <button className='btn btn-info' onClick={() => this._selectItem(item, 'comparison-details')}>
                            <i className='fa fa-eye' />
                          </button>
                        </td>
                        <td className='text-center'>
                          <button className='btn btn-danger' onClick={() => this._selectItem(item, 'delete')}>
                            <i className='fa fa-trash' />
                          </button>
                        </td>
                      </tr>
                    ))
                      : <tr>
                        <td colSpan='9' className='text-center'>- NO DATA -</td>
                      </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className='text-center'>
          {
            (markup.data && markup.data.total > 10) &&
            <Pagination
              innerClass='pagination'
              itemClass='page-item'
              linkClass='page-link'
              activePage={markup.data.page || this.state.page}
              itemsCountPerPage={10}
              totalItemsCount={markup.data.total}
              pageRangeDisplayed={5}
              onChange={this._changePage}
            />
          }
        </div>
      </section>
    )
  }

  render () {
    const { markup, preset } = this.props
    return (
      <div>
        <header className='section'>
          <div className='title-block d-flex mb-3'>
            <h3 className='title mr-auto'>
              Markup Price
              {
                (markup.fetching || markup.processing) &&
                <div className='badge badge-info ml-2'>{markup.fetching ? 'Loading' : 'Processing'} ...</div>
              }
            </h3>
            <button className='btn btn-primary ml-auto' onClick={() => this._toggleModal('create')}><i className='fa fa-plus' /> Add New Markup</button>
          </div>
        </header>

        {
          currentBranch() === 'ID' &&
          <div className='section'>
            <div className='card'>
              <div className='card-block'>
                <div className='form-inline'>
                  <div className='form-group mr-2'>
                    <label className='control-label mr-2 mb-2'>General Markup : </label>
                    <strong className='mb-2'>{preset.dataPresetOrder.general_price_offset} %</strong>
                  </div>
                  <div className='form-group mr-2'>
                    <button type='button' className='btn btn-dark btn-sm btn-link mb-2' onClick={() => this._selectGeneral(preset.dataPresetOrder.general_price_offset, 'edit-general')}>Edit</button>
                  </div>
                  <div className='form-group mb-2'>
                    {preset.fetchingPresetOrder && <span className='badge badge-info'>Saving ...</span>}
                    {preset.errPresetOrder && <span className='badge badge-danger'>{preset.errPresetOrder}</span>}
                  </div>
                </div>
              </div>
            </div>
          </div>
        }

        {
          currentBranch() === 'PH' &&
          <div className='section'>
            <div className='card'>
              <div className='card-block'>
                <div className='form-inline'>
                  <div className='form-group mr-2'>
                    <label className='control-label mr-2 mb-2'>General Markup (PH): </label>
                    <strong className='mb-2'>{ preset.dataBranch && preset.dataBranch.PH !== undefined && preset.dataBranch.PH.attraction } %</strong>
                  </div>
                  <div className='form-group mr-2'>
                    <button type='button' className='btn btn-dark btn-sm btn-link mb-2' onClick={() => this._selectGeneral(preset.dataBranch.PH.attraction, 'branch-ph')}>Edit</button>
                  </div>
                  <div className='form-group mb-2'>
                    {preset.fetchingBranch && <span className='badge badge-info'>Fetching ...</span>}
                    {preset.errBranch && <span className='badge badge-danger'>{preset.errPresetOrder}</span>}
                  </div>
                </div>
              </div>
            </div>
          </div>
        }

        { this._renderTable(markup) }

        {/* CREATE */}
        <Modal classNames={{ modal: 'modal-large' }} center open={this.state.showModal === 'create'} onClose={this._toggleModal} closeOnOverlayClick>
          <FormCreate closeModal={() => this._toggleModal()} />
        </Modal>

        {/* UPDATE */}
        <Modal classNames={{ modal: 'modal-large' }} center open={this.state.showModal === 'edit'} onClose={this._toggleModal} closeOnOverlayClick>
          <FormUpdate detail={this.state.detail} closeModal={() => this._toggleModal()} />
        </Modal>

        {/* DELETE */}
        <Modal classNames={{ modal: 'modal-large' }} center open={this.state.showModal === 'delete'} onClose={this._toggleModal} closeOnOverlayClick>
          <FormDelete detail={this.state.detail} closeModal={() => this._toggleModal()} />
        </Modal>

        {/* COMPARISON */}
        <Modal classNames={{ modal: 'modal-large' }} center open={this.state.showModal === 'comparison'} onClose={this._toggleModal} closeOnOverlayClick>
          <PriceComparison detail={this.state.detail} closeModal={() => this._toggleModal()} />
        </Modal>

        {/* COMPARISON-DETAILS */}
        <Modal classNames={{ modal: 'modal-large' }} center open={this.state.showModal === 'comparison-details'} onClose={this._toggleModal} closeOnOverlayClick>
          <ComparisonDetails detail={this.state.detail} closeModal={() => this._toggleModal()} />
        </Modal>

        {/* UPDATE GENERAL MARKUP */}
        <Modal center open={this.state.showModal === 'edit-general'} onClose={this._toggleModal} closeOnOverlayClick>
          <div className='section' style={{ width: '20vw' }}>
            <div className='title-block'>
              <h4 className='title mr-auto'>General Markup</h4>
            </div>
            <form onSubmit={(event) => this._updateGeneralMarkup(event)}>
              <div className='form-group' style={{ width: '50%' }}>
                <div className='input-group' >
                  <input type='number' name='value' required step='any' max={100} className='form-control' value={this.state.general_markup} onChange={(event) => this._valueChange(event, 'general_markup')} />
                  <div className='input-group-append'>
                    <span className='input-group-text'>%</span>
                  </div>
                </div>
              </div>
              <div className='form-group'>
                <button type='button' className='btn btn-secondary' onClick={() => this._toggleModal()}>Cancel</button>
                <button type='submit' className='btn btn-primary ml-2'>Save</button>
              </div>
            </form>
          </div>
        </Modal>

        {/* UPDATE PH GENERAL MARKUP */}
        <Modal center open={this.state.showModal === 'branch-ph'} onClose={this._toggleModal} closeOnOverlayClick>
          <div className='section' style={{ width: '20vw' }}>
            <div className='title-block'>
              <h4 className='title mr-auto'>General Markup</h4>
            </div>
            <form onSubmit={(event) => this._updateBranch(event, 'PH', 'attraction')}>
              <div className='form-group' style={{ width: '50%' }}>
                <div className='input-group' >
                  <input type='number' name='value' required step='any' max={100} className='form-control' value={this.state.branch.value} onChange={(event) => this._valueChange(event, 'branch-ph')} />
                  <div className='input-group-append'>
                    <span className='input-group-text'>%</span>
                  </div>
                </div>
              </div>
              <div className='form-group'>
                <button type='button' className='btn btn-secondary' onClick={() => this._toggleModal()}>Cancel</button>
                <button type='submit' className='btn btn-primary ml-2'>Save</button>
              </div>
            </form>
          </div>
        </Modal>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  markup: state.markup,
  preset: state.preset
})

const dispatchToProps = (dispatch) => ({
  getMarkup: (filter) => dispatch(MarkupActions.markupRequest(filter)),
  updateGeneralMarkup: (data) => dispatch(PresetActions.presetOrderUpdateRequest(data)),
  getGeneralMarkup: () => dispatch(PresetActions.presetOrderRequest()),
  getBranch: () => dispatch(PresetActions.getBranchRequest()),
  updateBranch: (data) => dispatch(PresetActions.updateBranchRequest(data))
})

export default connect(stateToProps, dispatchToProps)(Markup)



// WEBPACK FOOTER //
// ./src/Pages/Misc/Markup.js